document.addEventListener('DOMContentLoaded', () => {
  const accordion = document.querySelector('.df-accordion');

  if (!accordion) return

  const accordion_items = accordion.querySelectorAll('.df-accordion__item');

  accordion_items.forEach(item => {
    item.querySelector('.df-accordion__button').addEventListener('click', () => {
      accordion_items.forEach(element => {
        if (item !== element) {
          element.classList.remove('df-accordion__item_active')
        }
      })

      item.classList.toggle('df-accordion__item_active')
    })
  })
});
